// Primary color brand options:
// 1. Microsoft Fluent UI Figma Kit: #0F6CBD, Scheme & Mixer: Material & Analogous
// 2. IBM Design Language: Blue 60 (#0f62fe), Scheme & Mixer: Tailwind & Triadic Harmony

const vuetifyStudioLightTheme = {
  dark: false,
  colors: {
    // background_old: '#eceef4',
    // surface_old: '#f8f9ff',
    background: '#f9fafb',
    surface: '#ffffff',
    'surface-dim': '#d8dae1',
    'surface-bright': '#f8f9ff',
    'on-surface': '#181c21',
    outline: '#717783',
    'outline-variant': '#c1c7d4',
    primary: '#0060ab',
    'on-primary': '#ffffff',
    secondary: '#006782',
    'on-secondary': '#ffffff',
    tertiary: '#5652b4',
    'on-tertiary': '#ffffff',
    error: '#ba1a1a',
    'on-error': '#ffffff',
    'surface-light': '#e6e8ef',
  },
  // Refers to Vuetify documentation: https://vuetifyjs.com/en/features/theme/#customizing-variables
  // Properties defined inside `variables` will be translated to CSS variables/custom properties
  // Example: `disabled-opacity` will become `--v-disabled-opacity` in CSS
  variables: {
    'overlay-background': '#161c25',
    'disabled-opacity': 0.7, // Default is 0.38, used by disabled elements
  },
};

const vuetifyStudioDarkTheme = {
  dark: true,
  colors: {
    background: '#1c2025',
    surface: '#101418',
    'surface-dim': '#101418',
    'surface-bright': '#36393f',
    'on-surface': '#e0e2e9',
    outline: '#8b919d',
    'outline-variant': '#414752',
    primary: '#a3c9ff',
    'on-primary': '#00315c',
    secondary: '#7ed1f3',
    'on-secondary': '#003545',
    tertiary: '#c3c0ff',
    'on-tertiary': '#261e84',
    error: '#ffb4ab',
    'on-error': '#690005',
    'surface-light': '#36393f',
  },
  variables: {
    'overlay-background': '#161c25',
  },
};

export { vuetifyStudioDarkTheme, vuetifyStudioLightTheme };
